/* components/MobileMenu.ts
Site Mobile Menu

Example
<mobile-menu>
    Site header content here
</mobile-menu>
*/

import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from "@/theme/Cart";

@Component
export class MobileMenu extends ThemeComponent {

    @Ref({required: false}) cartTrigger!: HTMLDivElement;
    @Ref() cartCount!: HTMLSpanElement;

    constructor() {
        super();
    }

    init() {
        this.$subscribe(cart.onChange, () => {
            if (cart.getCartItemCount() <= 0) {
                this.cartCount.classList.remove('active');
            } else {
                this.cartCount.classList.add('active');
            }
            this.cartCount.textContent = cart.getCartItemCount().toString();
        });
    }
}
